/* eslint-disable  */
import hljs from 'highlight.js';
import MarkdownIt from 'markdown-it';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useMutation } from 'react-query';
// import {
//   deleteItemConversationService
// } from 'services/conversations';
import { Image, Typography } from 'tfc-components';

import { FilesIcon } from '@phosphor-icons/react';
import { Flex } from 'antd';
import { ReactComponent as Copy } from 'assets/icons/ic_copy.svg';
import { ReactComponent as Happy } from 'assets/icons/ic_happy.svg';
import { ReactComponent as Retry } from 'assets/icons/ic_retry_circle.svg';
import { ReactComponent as Sad } from 'assets/icons/ic_sad.svg';
import { ReactComponent as Speaker } from 'assets/icons/ic_speaker_high.svg';
import { ReactComponent as SpeakerActive } from 'assets/icons/ic_t2P_active.svg';
import avatarBot from 'assets/images/avatar.png';
import Icon from 'components/atoms/Icon';
import Loading from 'components/atoms/Loading';
import LoadingDots from 'components/atoms/LoadingDots';
import LoadingSpinner from 'components/atoms/LoadingSpinner';
import { useToast } from 'components/molecules/Toast';
import MarkdownReader from 'components/organisms/ChatMessage/MarkdownReader';
import CustomModal from 'components/organisms/Modal';
import { MessageChattingTypes } from 'components/templates/Chatting';
import { ContextChatbot } from 'components/templates/MainlayoutChatbot';
import { useTranslation } from 'react-i18next';
import { feedbackConversationService, T2PService } from 'services/accountConversations';
import {
  FeedbackConversationService,
  FeedBackEmojiType,
  KnowledgeUsagedTypes,
} from 'services/accountConversations/types';
import { useAppSelector } from 'store/hooks';
import mapModifiers from 'utils/functions';
import ActionMessage from '../ActionMessage';
import ModalViewImageChatbot from '../ModalViewImageChatbot';
import RenderFile from './RenderFile';
import dayjs from 'dayjs';
import { agentFeedbackConversationService, agentT2PService } from 'services/agents';
import { useSearchParams } from 'react-router-dom';

export type ChooseMessageType = 'whoAreU' | 'resendOtp';

export type ChooseMessageTypes = {
  id: string;
  text: string;
  value: string;
  type: ChooseMessageType;
};

interface ChatMessageProps {
  isRightSide?: boolean;
  avatar?: string;
  name?: string;
  question?: string;
  content?: string;
  isTyping?: boolean;
  isSearchingData?: boolean;
  loading?: boolean;
  failed?: boolean;
  code?: string;
  isCopy?: boolean;
  isRemove?: boolean;
  isAudio?: boolean;
  modeView?: boolean;
  hasActions?: boolean;
  actions?: Array<ChooseMessageTypes>;
  feedbackEmoji?: FeedBackEmojiType;
  conversationCode?: string;
  mainColor?: string;
  files?: Array<UploadFileType>;
  knowledgeUsaged?: Array<KnowledgeUsagedTypes>;
  attachedMedia?: Array<{
    fileName: string;
    fileUrl: string;
    source: string;
  }>;
  onHandleRetryAnswer?: (params: MessageChattingTypes) => void;
  onDeleteQAndA?: (code?: string) => void;
  onChooseMessage?: (ms: ChooseMessageTypes) => void;
  onUpdateActionForMessage?: (code: string, value?: FeedBackEmojiType) => void;
  onSendSuggestMessage?: () => void;
  isDisplay?: boolean;
  isPaused?: boolean;
  onContinueStreaming?: () => void;
  canRetry?: boolean;
  currentPlayingCode?: string | null;
  setCurrentPlayingCode?: (code: string | null) => void;
  processMsgType?: number;
  processCustomMsg?: string;
  isTestAgent?: boolean;
  exportChat?: {
    expiresAt: string;
    fileUrl: string;
  }[];
  timeResponse?: number;
  timeSendAt?: dayjs.Dayjs;
  userSendAt?: string;
}

let currentAudioPlaying: HTMLAudioElement | null = null;

const ChatMessage: React.FC<ChatMessageProps> = ({
  isRightSide,
  avatar,
  name,
  content,
  isTyping,
  isSearchingData,
  failed,
  code,
  files,
  question,
  loading,
  isCopy,
  isRemove,
  isAudio = false,
  feedbackEmoji,
  actions,
  conversationCode,
  hasActions = true,
  modeView,
  knowledgeUsaged,
  attachedMedia,
  onHandleRetryAnswer,
  onDeleteQAndA,
  onChooseMessage,
  onUpdateActionForMessage,
  onSendSuggestMessage,
  mainColor,
  isDisplay,
  // hasTypingEffect
  isPaused,
  onContinueStreaming,
  canRetry = true,
  currentPlayingCode,
  setCurrentPlayingCode,
  processMsgType,
  processCustomMsg,
  isTestAgent,
  exportChat,
  timeResponse,
  timeSendAt,
  userSendAt
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [isShowPopupDelete, setIsShowPopupDelete] = useState(false);
  const [copy, setCopy] = useState(false);
  const [activeSpeed, setActiveSpeed] = useState(false)
  const [imgUrl, setImgUrl] = useState('');
  const { showToast } = useToast();
  const [currentSoundUrl, setCurrentSoundUrl] = useState('');
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const audioUrlCache = useRef<Record<string, string>>({});
  const [showModalExpired, setShowModalExpired] = useState(false)
  const { t } = useTranslation()
  const infoChatbot = useContext(ContextChatbot);
  const { profile } = useAppSelector(state => state.auth)
  const [searchParms] = useSearchParams()
  const agentCode = searchParms.get('key') || ''
  const codeConversation = searchParms.get('code') || ''
  const md = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    highlight: (str: string, lang: string) => {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return `<pre><code class="hljs">${hljs.highlight(str, { language: lang, ignoreIllegals: true }).value
            }</code></pre>`;
        } catch (__) { }
      }

      return `<pre><code class="hljs">${md.utils.escapeHtml(str)}</code></pre>`;
    },
  }) as MarkdownIt;
  // add target="_blank" to all links
  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    tokens[idx].attrSet('target', '_blank');

    return self.renderToken(tokens, idx, options);
  };

  const { mutate: deleteItemConversationMutate, isLoading } = useMutation(
    'delete-item-conversation',
    // (params: { code: string }) => deleteItemConversationService(params),
    // TODO: update later
    (params: { code: string }) => new Promise((resolve) => resolve(code)),
    {
      onSuccess() {
        if (onDeleteQAndA) {
          onDeleteQAndA(code);
        }
      },
      onMutate() {
        setIsShowPopupDelete(false);
      },
    }
  );

  const { mutate: feedbackConvertationMutate, isLoading: feedbackLoading } = useMutation(
    'feedback-conversation',
    (params: FeedbackConversationService) => isTestAgent ? agentFeedbackConversationService(
      agentCode || '',
      codeConversation || '',
      code || '',
      params
    ) : feedbackConversationService(conversationCode || '', code || '', params),
    {
      onSuccess(_, variables) {
        if (onUpdateActionForMessage && code) {
          onUpdateActionForMessage(code, variables.feedbackEmoji);
        }
      },
    }
  );

  const { mutateAsync: readMessageMutate, isLoading: loadingRead } = useMutation({
    mutationKey: ['T2P'],
    mutationFn: T2PService,
    onMutate: () => {
      setCurrentSoundUrl('');
    },
    onSuccess: (data) => {
      const fullUrl = `${window.location.origin}${data.link}`;
      audioUrlCache.current[code || ''] = fullUrl;
      setCurrentSoundUrl(fullUrl);
    }
  })

  const { mutateAsync: AgentreadMessageMutate, isLoading: AgentloadingRead } = useMutation({
    mutationKey: ['T2P-agent', agentCode, codeConversation, code],
    mutationFn: agentT2PService,
    onMutate: () => {
      setCurrentSoundUrl('');
    },
    onSuccess: (data) => {
      const fullUrl = `${window.location.origin}${data.link}`;
      audioUrlCache.current[code || ''] = fullUrl;
      setCurrentSoundUrl(fullUrl);
    }
  })

  const copyText = () => {
    const text = contentRef.current?.textContent || '';
    if (!text) return;

    // Modern API
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopy(true);
          setTimeout(() => setCopy(false), 2000);
          showToast({ message: t('chatbot.copied'), show: true, type: 'success' });
        })
        .catch((err) => {
          console.error('Clipboard API failed:', err);
          fallbackCopyText(text);
        });
    } else {
      // Fallback
      fallbackCopyText(text);
    }
  };

  const fallbackCopyText = (text: string) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '1px';
    textArea.style.height = '1px';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const success = document.execCommand('copy');
      if (success) {
        setCopy(true);
        setTimeout(() => setCopy(false), 2000);
        showToast({ message: t('chatbot.copied'), show: true, type: 'success' });
      } else {
        showToast({ message: 'Trình duyệt không hỗ trợ sao chép.', show: true, type: "error" });
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      showToast({ message: 'Không thể sao chép nội dung.', show: true, type: "error" });
    }

    document.body.removeChild(textArea);
  };
  const handleReadContent = () => {
    if (activeSpeed) {
      setActiveSpeed(false)
      setCurrentPlayingCode?.(null);
      return;
    }

    setCurrentPlayingCode?.(code || null);
    setActiveSpeed(true)

    // Kiểm tra cache trước
    const cachedUrl = audioUrlCache.current[code || ''];
    if (cachedUrl) {
      setCurrentSoundUrl(cachedUrl);
      return;
    }

    if (isTestAgent) {
      AgentreadMessageMutate({
        code: agentCode || "",
        conversationCode: codeConversation || "",
        itemCode: code || ""
      })
    }
    else {
      readMessageMutate({
        code: code || "",
        conversationCode: conversationCode || ""
      })
    }

  }

  const onHandleAction = (ac: ChooseMessageTypes) => {
    if (onChooseMessage) {
      onChooseMessage(ac);
    }
  };

  const handleDownfile = (item: { expiresAt: string; fileUrl: string; }) => {
    const isExpired = new Date(item.expiresAt) < new Date();
    if (isExpired) {
      setShowModalExpired(true)
      return;
    }
    window.open(`${window.location.origin}${item.fileUrl}`, '_blank');
  }

  useEffect(() => {
    if (contentRef.current && !isRightSide) {
      const links = contentRef.current.querySelectorAll('.m-chatMessage a[href^="https://picsum.photos/id/1/"');
      const imgEle = document.createElement('img');
      links.forEach((l) => {
        imgEle.classList.add('m-chatMessage_streamImg');
        imgEle.src = l.getAttribute('href') || '';
        imgEle.alt = l.textContent || '';
        imgEle.style.cursor = 'pointer';
        l.parentElement?.replaceChild(imgEle, l);
      });

      imgEle.addEventListener('click', (e) => {
        if (imgEle.src) setImgUrl(imgEle.src);
      });
    }
  }, []);

  // Chỉ khởi tạo 1 lần duy nhất
  useEffect(() => {
    audioRef.current = new Audio();
    return () => {
      // cleanup khi unmount
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, []);

  // Khi thay đổi URL, cập nhật src
  useEffect(() => {
    if (audioRef.current && currentSoundUrl) {
      audioRef.current.src = currentSoundUrl;
    }
  }, [currentSoundUrl]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleEnded = () => {
      setActiveSpeed(false);
      currentAudioPlaying = null; // khi phát xong
    };

    if (activeSpeed) {
      // Nếu đang có audio khác phát → dừng nó lại
      if (currentAudioPlaying && currentAudioPlaying !== audio) {
        currentAudioPlaying.pause();
        currentAudioPlaying.currentTime = 0;
      }

      // Cập nhật currentAudioPlaying
      currentAudioPlaying = audio;

      audio.play().catch((err) => console.error('Play error:', err));
      audio.addEventListener('ended', handleEnded);
    } else {
      if (audio === currentAudioPlaying) {
        audio.pause();
        audio.currentTime = 0;
        currentAudioPlaying = null;
      }
      audio.removeEventListener('ended', handleEnded);
    }

    return () => {
      audio.removeEventListener('ended', handleEnded);
    };
  }, [activeSpeed, currentSoundUrl]);

  useEffect(() => {
    if (currentPlayingCode !== code && activeSpeed) {
      setActiveSpeed(false);
    }
  }, [currentPlayingCode]);
  return (
    <div className={`m-chatMessage${isRightSide ? ' reverse' : ''}`}>
      <div className={`m-chatMessage_message ${!content && isPaused ? "m-chatMessage_message-hidden" : ""}`}>
        <div className={`m-chatMessage_wrap ${onSendSuggestMessage ? 'clickable' : ''}`} onClick={onSendSuggestMessage}>
          {isRightSide && files && files.length > 0 && <RenderFile files={files} />}
          <div
            className={mapModifiers(
              'm-chatMessage_content',
              failed ? 'failed' : '',
              onSendSuggestMessage ? 'clickable' : ''
            )}
            style={
              !failed && isRightSide && mainColor ? ({ '--message-bg-color': mainColor } as React.CSSProperties) : {}
            }
          >
            {!isRightSide && (
              <div className="m-chatMessage_nameWrapper">
                <div className="m-chatMessage_avatar">
                  <Image imgSrc={avatar || avatarBot} ratio={1} alt="avatar" />
                </div>
                <Typography.Heading type="h6" fontweight="600" extendClasses="fs-16x20">
                  {name}
                </Typography.Heading>
              </div>
            )}
            {content && (
              <div ref={contentRef}>
                <MarkdownReader content={content} />
              </div>
            )}
            {knowledgeUsaged && knowledgeUsaged.length > 0 && (
              <>
                <div className="m-chatMessage_divider" />
                <Typography.Text extendClasses="m-chatMessage_source_title" fontweight="600">
                  {t('chatbot.source')}
                </Typography.Text>
                <div className="m-chatMessage_source">
                  {knowledgeUsaged?.map((source) =>
                  (
                    <a target="_blank" href={source.fileUrl} className="m-chatMessage_source_item">
                      <Icon iconName={source.source === 'upload' ? 'fileUpload' : 'globe'} size="20x20" />
                      <span>{source.fileName}</span>
                    </a>
                  )
                  )}
                </div>
              </>
            )}
            {attachedMedia && attachedMedia.length > 0 && (
              <>
                <div className="m-chatMessage_divider" />
                <Typography.Text extendClasses="m-chatMessage_source_title" fontweight="600">
                  {t('chatbot.attachedMedia')}
                </Typography.Text>
                <div className="m-chatMessage_source">
                  {attachedMedia?.map((source) =>
                  (
                    <a target="_blank" href={source.fileUrl} className="m-chatMessage_source_item">
                      <Icon iconName={source.source === 'upload' ? 'fileUpload' : 'globe'} size="20x20" />
                      <span>{source.fileName}</span>
                    </a>
                  )
                  )}
                </div>
              </>
            )}
            {!isRightSide && actions && actions?.length > 0 && (
              <ul className="m-chatMessage_messageAct">
                {actions.map((item) => (
                  <li
                    role="button"
                    className="m-chatMessage_content_text m-chatMessage_content_text-action"
                    onClick={() => onHandleAction(item)}
                    key={item.id}
                  >
                    {item.text}
                  </li>
                ))}
              </ul>
            )}

            { /* User Send At */}
            {isRightSide && userSendAt && <Flex className='m-chatMessage_timeSpacing' justify='end'>
              <Typography.Text extendClasses='fs-12x14'>
                {dayjs(userSendAt).format('HH:mm')}
              </Typography.Text>
            </Flex>}


            {isTyping && <p style={{ "--chatbot-color": infoChatbot.mainColor || mainColor } as React.CSSProperties} className="m-chatMessage_loadingGradient">{processMsgType === 2 ? processCustomMsg : <LoadingDots />}</p>}
            {isSearchingData && <p style={{ "--chatbot-color": infoChatbot.mainColor || mainColor } as React.CSSProperties} className="m-chatMessage_loadingGradient">{processMsgType === 2 ? processCustomMsg : <LoadingDots />}</p>}
            <Flex style={{
              marginTop: 14
            }} vertical gap={8}>
              {exportChat && exportChat.length > 0 && exportChat.map((item, index) => (
                <div onClick={() => handleDownfile(item)} className="m-chatMessage_exportChat" key={`index-export-${index.toString()}`}>
                  <FilesIcon size={20} />
                  <Typography.Text>{t('chatbot.downloadFile')}</Typography.Text>
                </div>
              ))}
            </Flex>
            <div className="m-chatMessage_action">
              {content && hasActions && !isRightSide && (
                <div className="m-chatMessage_actionMessage">
                  <ActionMessage
                    data={[
                      {
                        icon: <Happy className={mapModifiers('m-chatMessage_happy', feedbackEmoji === 'happy' ? 'active' : '')} />,
                        tooltip: '',
                        isActive: feedbackEmoji === 'happy',
                        activeIcon: 'happyActive',
                        disabled: isDisplay || modeView || !!feedbackEmoji,
                        handleClick: () =>
                          feedbackConvertationMutate({
                            feedbackEmoji: 'happy',
                          }),
                      },
                      {
                        icon: <Sad className={mapModifiers('m-chatMessage_happy', feedbackEmoji === 'sad' ? 'active' : '')} />,
                        tooltip: '',
                        isActive: feedbackEmoji === 'sad',
                        activeIcon: 'sadActive',
                        disabled: isDisplay || modeView || !!feedbackEmoji,
                        handleClick: () =>
                          feedbackConvertationMutate({
                            feedbackEmoji: 'sad',
                          }),
                      },
                      ...((isTestAgent ? profile?.tierData?.allowT2s : infoChatbot.tierData.allowT2s) ? [{
                        icon: code === currentPlayingCode && (loadingRead || AgentloadingRead) ? <Flex style={{ "--chatbot-color": infoChatbot.mainColor || mainColor } as React.CSSProperties}
                          align='center' className='m-chatMessage_loadingRead'> <LoadingSpinner /></Flex> :
                          (code === currentPlayingCode && activeSpeed) ? <SpeakerActive className={'m-chatMessage_speakActive'} /> : <Speaker className={'m-chatMessage_speaker'} />,
                        tooltip: code === currentPlayingCode && activeSpeed ? t('chatbot.stop') : t('chatbot.read'),
                        disabled: isDisplay || modeView,
                        handleClick: () => handleReadContent(),
                        isActive: activeSpeed
                      }] : []),
                      ...(canRetry
                        ? [
                          {
                            icon: <Retry className={mapModifiers('m-chatMessage_retry')} />,
                            tooltip: t("chatbot.tryAgain"),
                            disabled: isDisplay || modeView,

                            handleClick: () => {
                              if (onHandleRetryAnswer) {
                                onHandleRetryAnswer({
                                  code,
                                  files,
                                  message: question,
                                });
                              }
                            },
                          },
                        ]
                        : []),
                      {
                        icon: <Copy className={mapModifiers('m-chatMessage_retry')} />,
                        tooltip: t("chatbot.copy"),
                        disabled: isDisplay,
                        handleClick: () => copyText(),
                      },
                    ]}
                  />
                </div>
              )}
              <Flex align='center'>
                {
                  (isTestAgent ? !profile?.customerData?.isPro : !infoChatbot?.isPro) && <Flex className='m-chatMessage_time' align="center" gap={4}>
                    { /* ChatBot Response Time */}
                    {!isRightSide && timeResponse ? <>
                      <Typography.Text fontweight='600' extendClasses='m-chatMessage_timeResponse fs-12x14'>
                        {timeResponse} ms
                      </Typography.Text>
                      <div className='m-chatMessage_dividerVertical' />
                    </> : null}

                    { /* Bot send time */}

                  </Flex>
                }
                {!isRightSide && timeSendAt && <Typography.Text extendClasses='fs-12x14'>
                  {timeSendAt?.format('HH:mm')}
                </Typography.Text>}
              </Flex>
              {!isRightSide && isPaused && onContinueStreaming && (
                <button type="button" className="m-chatMessage_continue" onClick={onContinueStreaming}>
                  <Icon iconName="arrowsClockwise" size="20x20" className="m-chatMessage_continue_icon" />
                  <Typography.Text>{t('chatbot.continue')}</Typography.Text>
                </button>
              )}
            </div>


          </div>
          {(isLoading || feedbackLoading || loading) && <Loading variant="abs" />}
        </div>
      </div>
      <CustomModal
        isOpen={isShowPopupDelete}
        okButton={{
          handleClick: () => {
            if (code) {
              deleteItemConversationMutate({ code });
            }
          },
          text: t('chatbot.yes'),
        }}
        cancelButton={{
          handleClick: () => {
            setIsShowPopupDelete(false);
          },
          text: t('chatbot.no'),
        }}
      >
        <Typography.Heading type="h6" textStyle="center">
          {t('chatbot.confirmDelMessage')}
        </Typography.Heading>
      </CustomModal>
      <ModalViewImageChatbot imgUrl={imgUrl} onClose={() => setImgUrl('')} />

      <CustomModal
        closeIcon={true}
        isOpen={showModalExpired}
        cancelButton={
          { handleClick: () => setShowModalExpired(false) }
        }
      >
        <div className='m-chatMessage_sadIcon'>
          <Icon iconName='smileySad' size='40' />
        </div>
        <Flex vertical gap={12}>
          <Typography.Text fontweight='600' extendClasses='fs-16x24' textStyle="center">
            {t('chatbot.expiredLink')}
          </Typography.Text>
          <Typography.Text textStyle="center">
            {t('chatbot.linkTimeOut')}
          </Typography.Text>
        </Flex>
      </CustomModal>
    </div>
  );
};
export default ChatMessage;
